var vec3 = require('@antv/gl-matrix/lib/gl-matrix/vec3');

module.exports = vec3;